export default __webpack_public_path__ + "static/media/spin-banner.0deb0e9e.png";